function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.833 6.333H13.5V4.556c0-.943-.369-1.848-1.025-2.515A3.473 3.473 0 0 0 10 1c-.928 0-1.819.375-2.475 1.041A3.584 3.584 0 0 0 6.5 4.556v1.777H4.167c-.31 0-.606.125-.825.347A1.195 1.195 0 0 0 3 7.52v8.296c0 .314.123.616.342.838.219.222.515.347.825.347h11.666c.31 0 .606-.125.825-.347.22-.222.342-.524.342-.838V7.519c0-.315-.123-.616-.342-.839a1.157 1.157 0 0 0-.825-.347ZM4.167 9.89h11.666v1.185H4.167V9.89Zm0 2.37h11.666v1.185H4.167V12.26Zm3.5-7.703c0-.63.245-1.232.683-1.677A2.315 2.315 0 0 1 10 2.185c.619 0 1.212.25 1.65.694a2.39 2.39 0 0 1 .683 1.677v1.777H7.667V4.556Zm8.166 2.963v1.185H4.167V7.519h11.666Zm0 8.296H4.167V14.63h11.666v1.185Z",
    fill: "#737373",
    style: {
      fill: "color(display-p3 .45 .45 .45)",
      fillOpacity: 1
    }
  }));
};

export default SvgLock;